import type { Platform, ShareContent } from '../types';
import { buildShareUrl } from '../utils/url';
import { PlatformRegistry } from './registry';

export const x: Platform = {
  id: 'x',
  name: 'X',
  iconIndex: PlatformRegistry.x.index,
  color: PlatformRegistry.x.color,
  buildUrl: (content: ShareContent): string => {
    return buildShareUrl('https://x.com/intent/post', {
      text: content.title,
      url: content.url,
      hashtags: content.hashtags,
    });
  },
};

